export default __webpack_public_path__ + "static/planning-development-accomplishment-3-1a2ce0008fc52772cedb124f34a63b6c.webp";